/* ==========================================================================
   CROWN BIO LIFE - PREMIUM JAVASCRIPT SYSTEM
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  

  // ---------------------------------------------------------
  // 2. Ripple Click Effects
  // ---------------------------------------------------------
  const rippleButtons = document.querySelectorAll('.ripple');
  rippleButtons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      const circle = document.createElement('span');
      const diameter = Math.max(this.clientWidth, this.clientHeight);
      const radius = diameter / 2;

      const rect = this.getBoundingClientRect();
      circle.style.width = circle.style.height = `${diameter}px`;
      circle.style.left = `${e.clientX - rect.left - radius}px`;
      circle.style.top = `${e.clientY - rect.top - radius}px`;
      circle.classList.add('ripple-effect');

      const existingRipple = this.querySelector('.ripple-effect');
      if (existingRipple) {
        existingRipple.remove();
      }

      this.appendChild(circle);
    });
  });

  // ---------------------------------------------------------
  // 3. Scroll Reveal (Intersection Observer)
  // ---------------------------------------------------------
  const revealElements = document.querySelectorAll('.reveal-on-scroll');
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
        revealObserver.unobserve(entry.target); // Reveal once
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -40px 0px'
  });

  revealElements.forEach(el => revealObserver.observe(el));

  // ---------------------------------------------------------
  // 4. Floating Header (Sticky Scroll Adjustments)
  // ---------------------------------------------------------
  const navbar = document.getElementById('navbar');
  const navLinks = document.querySelectorAll('.nav-link');
  
  window.addEventListener('scroll', () => {
    if (window.scrollY > 40) {
      navbar.classList.add('scrolled');
    } else {
      navbar.classList.remove('scrolled');
    }
    
    // Auto-update active link based on section viewports
    let current = '';
    const sections = document.querySelectorAll('section');
    sections.forEach(section => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.clientHeight;
      if (window.scrollY >= (sectionTop - 120)) {
        current = section.getAttribute('id');
      }
    });

    navLinks.forEach(link => {
      link.classList.remove('active');
      if (link.getAttribute('href') === `#${current}`) {
        link.classList.add('active');
      }
    });
  });

  // ---------------------------------------------------------
  // 5. Mobile Toggle Navigation
  // ---------------------------------------------------------
  const mobileToggle = document.getElementById('mobileToggle');
  const navMenu = document.getElementById('navMenu');
  
  mobileToggle.addEventListener('click', () => {
    mobileToggle.classList.toggle('open');
    navMenu.classList.toggle('open');
  });

  // Close mobile nav menu on clicking any link
  navLinks.forEach(link => {
    link.addEventListener('click', () => {
      mobileToggle.classList.remove('open');
      navMenu.classList.remove('open');
    });
  });

  // ---------------------------------------------------------
  // 6. Stats Increments Counter
  // ---------------------------------------------------------
  const statNumbers = document.querySelectorAll('.stat-number');
  
  const statsObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const targetEl = entry.target;
        const targetVal = parseFloat(targetEl.getAttribute('data-target'));
        const isDecimal = targetVal % 1 !== 0;
        
        let currentVal = 0;
        const duration = 1500; // 1.5 seconds
        const stepTime = 15;
        const totalSteps = duration / stepTime;
        const increment = targetVal / totalSteps;
        
        let step = 0;
        
        const counterInterval = setInterval(() => {
          currentVal += increment;
          step++;
          
          if (step >= totalSteps) {
            clearInterval(counterInterval);
            // Lock value
            if (targetVal === 99.9) targetEl.innerText = '99.9%';
            else if (targetVal === 450) targetEl.innerText = '450+';
            else if (targetVal === 100) targetEl.innerText = '100%';
            else if (targetVal === 24) targetEl.innerText = '24/7';
            else targetEl.innerText = targetVal;
          } else {
            if (isDecimal) {
              targetEl.innerText = currentVal.toFixed(1) + '%';
            } else {
              targetEl.innerText = Math.floor(currentVal) + (targetVal === 450 ? '+' : (targetVal === 100 ? '%' : ''));
            }
          }
        }, stepTime);
        
        statsObserver.unobserve(targetEl);
      }
    });
  }, { threshold: 0.5 });

  statNumbers.forEach(num => statsObserver.observe(num));



  // Bind inquiry card buttons to contact fields
  const cardInquiryBtns = document.querySelectorAll('.btn-card-action');
  cardInquiryBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      const itemName = btn.getAttribute('data-item');
      const cardType = btn.closest('.catalog-card').getAttribute('data-type');
      
      if (cardType === 'raw') {
        document.getElementById('selectedMaterialInput').value = itemName;
      } else {
        document.getElementById('selectedPackagingInput').value = itemName;
      }
    });
  });


  // ---------------------------------------------------------
  // 9. B2B Sourcing Inquiry Form Validations
  // ---------------------------------------------------------
  const inquiryForm = document.getElementById('inquiryForm');
  const formSuccess = document.getElementById('formSuccess');
  const submitBtn = document.getElementById('submitBtn');
  const submitSpinner = submitBtn ? submitBtn.querySelector('.submit-spinner') : null;
  const resetFormBtn = document.getElementById('resetFormBtn');

  if (inquiryForm && submitBtn) {
    function validateEmail(email) {
      const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return re.test(String(email).toLowerCase());
    }

    inquiryForm.addEventListener('submit', (e) => {
      e.preventDefault();
      let isFormValid = true;
      
      // Input elements to validate
      const inputs = [
        { id: 'clientName', check: val => val.trim() !== '' },
        { id: 'clientCompany', check: val => val.trim() !== '' },
        { id: 'clientEmail', check: val => validateEmail(val) },
        { id: 'requiredQuantity', check: val => val.trim() !== '' }
      ];
      
      inputs.forEach(item => {
        const el = document.getElementById(item.id);
        if (el) {
          const val = el.value;
          const formGroup = el.closest('.form-group');
          
          if (!item.check(val)) {
            if (formGroup) formGroup.classList.add('error');
            isFormValid = false;
          } else {
            if (formGroup) formGroup.classList.remove('error');
          }
        }
      });

      if (isFormValid) {
        // Show loading spinner
        submitBtn.disabled = true;
        if (submitSpinner) submitSpinner.style.display = 'inline-block';
        submitBtn.querySelector('span').innerText = 'Sending to our team...';
        
        // Simulate API call to B2B portal
        setTimeout(() => {
          if (submitSpinner) submitSpinner.style.display = 'none';
          submitBtn.disabled = false;
          submitBtn.querySelector('span').innerText = 'Send Price Inquiry';
          
          // Open Success Overlay
          if (formSuccess) formSuccess.style.display = 'flex';
        }, 1800);
      }
    });

    // Clear errors dynamically on input
    const inputElements = inquiryForm.querySelectorAll('input, textarea');
    inputElements.forEach(el => {
      el.addEventListener('input', () => {
        const group = el.closest('.form-group');
        if (group) group.classList.remove('error');
      });
    });

    // Reset Form Action
    if (resetFormBtn) {
      resetFormBtn.addEventListener('click', () => {
        inquiryForm.reset();
        if (formSuccess) formSuccess.style.display = 'none';
      });
    }
  }

  // ---------------------------------------------------------
  // 10. Dynamic Showcase Image Transition Loader
  // ---------------------------------------------------------
  // This manages transition from placeholders to generated images
  function initImages() {
    const heroImage1 = document.getElementById('heroImage1');
    const heroImage2 = document.getElementById('heroImage2');
    
    // Check if the generated image files have been placed in the directory
    // In our build setup we will overwrite these paths with the generated ones
    const path1 = '/assets/raw_materials_showcase.png';
    const path2 = '/assets/packaging_materials_showcase.png';
    
    if (heroImage1) {
      const imgTester1 = new Image();
      imgTester1.onload = function() {
        heroImage1.src = path1;
        heroImage1.style.display = 'block';
        heroImage1.classList.add('active');
        const fallback = heroImage1.nextElementSibling;
        if (fallback && fallback.classList.contains('image-fallback')) {
          fallback.style.display = 'none';
        }
      };
      imgTester1.src = path1;
    }

    if (heroImage2) {
      const imgTester2 = new Image();
      imgTester2.onload = function() {
        heroImage2.src = path2;
        heroImage2.style.display = 'block';
        heroImage2.classList.add('active');
        const fallback = heroImage2.nextElementSibling;
        if (fallback && fallback.classList.contains('image-fallback')) {
          fallback.style.display = 'none';
        }
      };
      imgTester2.src = path2;
    }
  }
  
  // Try to load images
  initImages();
  
  // Expose image checking function to window so we can trigger it after generation
  window.checkGeneratedImages = initImages;

  // ---------------------------------------------------------
  // 11. 4-Column Grid Logic (packaging.html)
  // ---------------------------------------------------------
  const filterBtns = document.querySelectorAll('.filter-btn');
  const precisionCards = document.querySelectorAll('.precision-card');
  const askPriceBtns = document.querySelectorAll('.btn-ask-price');
  const packInput = document.getElementById('selectedPackagingInput');
  const inquirySection = document.getElementById('inquiry');

  if (filterBtns.length > 0 && precisionCards.length > 0) {
    // Filter logic
    filterBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const filterVal = btn.getAttribute('data-filter');
        
        // Update active class
        filterBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        
        // Filter boxes
        precisionCards.forEach(box => {
          if (filterVal === 'all' || box.getAttribute('data-category') === filterVal) {
            box.style.display = 'flex';
          } else {
            box.style.display = 'none';
          }
        });
      });
    });

    // Ask for Price Logic
    askPriceBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const itemName = btn.getAttribute('data-item');
        
        if (packInput) {
          packInput.value = itemName;
          packInput.style.borderColor = 'var(--primary)';
          setTimeout(() => {
            packInput.style.borderColor = 'var(--border-light)';
          }, 1500);
        }
        
        if (inquirySection) {
          const topPos = inquirySection.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({
            top: topPos,
            behavior: 'smooth'
          });
        }
      });
    });
  }

});
